export default __webpack_public_path__ + "static/media/housessunset.2e24f2bf.jpg";